<template>
  <el-dialog
    :title="$t('title.AlarmReceiver')"
    :visible.sync="dialogBind"
    :before-close="doClose"
    width="60%"
    class="abow_dialog"
    style="height: 300px; margin-top: 15%;"
  >
  <el-form ref="AlarmRform" :model="AlarmRform" label-width="160px">
        <el-row :gutter="24">
          <el-col :xs="24">
            <el-form-item :label="$t('title.AlarmReceiver')">
              <el-select
                v-model="AlarmRform.contacts"
                multiple=""
                filterable
                :placeholder="$t('desc.select')"
                style="width: 80%"
              >
                <el-option
                  v-for="(item, index) in managerList"
                  :value="item.emailAddress"
                  :label="item.name"
                  :key="'inx3' + index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item>
              <el-button type="success" @click="onSubBtn">{{
                $t("button.confirm")
              }}</el-button>
              <el-button @click="doClose">{{
                $t("button.cancel")
              }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
  </el-dialog>
</template>
<script>
import { GetAllManererUser, getDeviceByDsn, updateDeviceAlarmContacts } from "../../../api/api";
export default {
  name: "index",
  props: {
    dialogBind: false,
    emailDsn: "",
    loading: false,
  },
  data() {
    return {
      managerList:[],
      deviceId:"",
      AlarmRform:{}
    };
  },
  watch: {
    dialogBind: {
      async handler(newValue, oldValue) {
        if (newValue === true) {
          await this.getDevice();
        }
      },
      deep: true,
    },
  },
  created: function () {
    this.getAllUser();
  },
  methods: {
    async getAllUser() {
      var that = this;
      let res = await GetAllManererUser();
      that.managerList = res.result;
    },
    async getDevice(){
      var that = this;
      let res = await getDeviceByDsn(that.emailDsn);
      this.deviceId = res.result.id;
      that.AlarmRform.contacts = JSON.parse(res.result.alarmContacts)?.email;
    },

    async onSubBtn() {
      let contacts = {
        email: this.AlarmRform.contacts
      }
      let postData = {
        Id: this.deviceId,
        AlarmContacts: JSON.stringify(contacts)
      };
      try {
        await updateDeviceAlarmContacts(postData);
        this.$message({
          showClose: true,
          message: this.$t("tips.updateSuccess"),
          type: "success",
        });
      } catch (error) {
        this.$message({
          showClose: true,
          message: err.error.message,
          type: "error",
        });
      }
      await this.doClose();
    },
    async doClose() {
      await this.$emit("dialogVisibleEvent", false);
      this.AlarmRform.contacts = new Array();
    },
  },
};
</script>
